import { errorNotifier } from "../../..";
import http, { AUTH_ROUTES } from "../../../service/api";

// export const getGroupChatMessages = (groupId) => `https://f8.codester.dev/web/api/groups/${groupId}/messages` //f8
// export const sendGroupChatMessage = (groupId) => `https://f8.codester.dev/web/api/groups/${groupId}/messages` //f8

export const getGroupChatMessages = (groupId) => `https://f8.codester.dev/api/groups/${groupId}/messages` //f8
export const sendGroupChatMessage = (groupId) => `https://f8.codester.dev/api/groups/${groupId}/messages` //f8

export const getGroup = async (setGroup, acct_type, id, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_GROUP(acct_type, id));
    setGroup(data?.data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const getUserGroups = async (setGroups, setLoading) => {
  try {
    const res = await http.get(AUTH_ROUTES.GET_USER_GROUPS());
    setGroups(res?.data?.data);
    //console.log('setGroups: ', res?.data?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};

export const sendGroupChat = async (payload, acct_type, setLoading) => {
  try {
    const data = await http.post(
      AUTH_ROUTES.SEND_GROUP_MESSAGE(acct_type),
      payload
    );
    setLoading(false);
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data?.data?.message);
  }
};

//chatId is same as groupMessageId frm backend
export const deleteGroupMessage = async (chatId) => {
  return await http.get(AUTH_ROUTES.DELETE_GROUP_MESSAGE(chatId));
};
